import $ from 'jquery';
import 'select2';
function normalizeSearchValue(value) {
    return value
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
}
export function prefixMatcher(params, data) {
    const rawTerm = (params.term || '').trim();
    const text = data.text.trim();
    if (rawTerm === '' || text === '') {
        return data;
    }
    const term = normalizeSearchValue(rawTerm);
    const normalizedText = normalizeSearchValue(text);
    if ('children' in data && data.children?.length) {
        const matchingChildren = data.children
            .map(child => prefixMatcher(params, child))
            .filter((child) => child !== null);
        if (matchingChildren.length) {
            return {
                ...data,
                children: matchingChildren,
            };
        }
    }
    return normalizedText.startsWith(term) ? data : null;
}
export default class Select2Forms {
    static isSelectOpenPrevented = false;
    static init($container = $('body')) {
        $container
            .find('select')
            .filter((index, element) => !$(element).data('select2'))
            .each((index, element) => {
            const $element = $(element);
            const $elementParent = $element.parent();
            $element.select2({
                theme: 'nbw',
                ...(!$element.data('search') ? { minimumResultsForSearch: Infinity } : {}),
                ...(this.getMatcher($element) ? { matcher: this.getMatcher($element) } : {}),
                dropdownParent: $element.data('parent-selector'),
            });
            $elementParent.append($element);
            $elementParent.find('span[aria-readonly="true"]').removeAttr('aria-readonly');
            const $clearButton = $elementParent.find('.js__clear-select');
            this.setClearButtonAttributes($element, $clearButton);
            $clearButton
                .on('click', () => {
                $element.val('').trigger('change');
            })
                .on('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    $element.val('').trigger('change');
                    // @ts-ignore
                    $element.select2('focus');
                }
            });
            $element.on('change', event => {
                this.setSelectedClass($(event.target));
                if ($element.closest('.is-invalid').length) {
                    $element.valid();
                }
                if ($clearButton.length) {
                    this.setClearButtonAttributes($element, $clearButton);
                }
            });
            $elementParent.find('span[role="textbox"]').removeAttr('role');
            // make select open after inputs validation
            $element.on('select2:opening', event => {
                if (!this.isSelectOpenPrevented) {
                    event.preventDefault();
                    this.isSelectOpenPrevented = true;
                    requestAnimationFrame(() => {
                        $(event.currentTarget).select2('open');
                        this.isSelectOpenPrevented = false;
                    });
                }
            });
            const $filterWrapper = $element.closest($element.data('filter-wrapper'));
            const $filterElement = $filterWrapper.find($element.data('filter-element'));
            const $filterElementInput = $filterElement.filter('input:checked');
            $filterElement.filter('input').on('change', (event) => {
                this.filterSelectOptions($(event.currentTarget), $element);
            });
            if ($filterElementInput.length) {
                this.filterSelectOptions($filterElementInput, $element);
            }
            this.setSelectedClass($element);
        });
    }
    static getMatcher($element) {
        const searchMode = String($element.data('search-mode') || '');
        if (searchMode === 'prefix') {
            return prefixMatcher;
        }
        return undefined;
    }
    static setClearButtonAttributes($element, $clearButton) {
        if ($element.val()) {
            $clearButton.attr('tabindex', '0');
        }
        else {
            $clearButton.removeAttr('tabindex');
        }
    }
    static filterSelectOptions($filterElement, $select) {
        const filterValue = $filterElement.val();
        const filterParameter = String($select.data('filter-parameter') || '');
        $select
            .find('option')
            .prop('disabled', false)
            .filter((index, element) => {
            return $(element).data(filterParameter) !== filterValue;
        })
            .prop('disabled', true);
        if (!$select.prop('disabled')) {
            $select.val('').trigger('change');
        }
    }
    static setSelectedClass($element) {
        $element.data('select2').$container.toggleClass('select2-container--selected', $element.val() !== '');
    }
}
